function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 297.453,
  cy: 323.304,
  rx: 243.526,
  ry: 40.6967,
  fill: "#8BCEFF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.6,
  d: "M536.874 319.348C536.874 319.437 536.874 319.527 536.874 319.616C536.874 319.616 483.453 357.218 297.45 357.218C111.446 357.218 58.0257 319.616 58.0257 319.616C58.0254 319.437 58.0252 319.258 58.0252 319.079C58.0252 317.988 58.0312 316.899 58.043 315.811C79.0889 296.914 178.272 282.607 297.45 282.607C416.627 282.607 515.81 296.914 536.856 315.811C536.868 316.899 536.874 317.988 536.874 319.079L536.874 319.348Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M536.874 319.397C536.874 319.218 536.874 319.039 536.874 318.86C536.874 172.601 429.68 54.0349 297.45 54.0349C165.219 54.0349 58.0252 172.601 58.0252 318.86C58.0252 319.039 58.0254 319.218 58.0257 319.397C58.0257 319.397 111.446 356.999 297.45 356.999C483.453 356.999 536.874 319.397 536.874 319.397Z",
  fill: "url(#paint0_radial)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M536.875 319.129C536.875 319.218 536.875 319.308 536.874 319.397C536.874 319.397 483.454 356.999 297.45 356.999C111.447 356.999 58.0266 319.397 58.0266 319.397C58.0263 319.218 58.0261 319.039 58.0261 318.86C58.0261 317.769 58.032 316.68 58.0439 315.592C79.0898 296.695 178.273 282.389 297.451 282.389C416.628 282.389 515.81 296.695 536.857 315.592C536.869 316.68 536.875 317.769 536.875 318.86L536.875 319.129Z",
  fill: "#8BCEFF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M282.112 325.33V281.181H291.863V325.33H282.112Z",
  fill: "#4035C2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M253.583 325.329H292.213C292.213 314.662 283.565 306.014 272.898 306.014C262.23 306.014 253.583 314.662 253.583 325.329Z",
  fill: "url(#paint1_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M301.363 325.33V281.181H311.113V325.33H301.363Z",
  fill: "#4035C2"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M301.363 325.33H339.993C339.993 314.662 331.345 306.014 320.678 306.014C310.01 306.014 301.363 314.662 301.363 325.33Z",
  fill: "url(#paint2_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.247 264.395L254.323 240.364L261.806 246.615L241.73 270.647L234.247 264.395Z",
  fill: "#4035C2"
});

var _ref11 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 9.65752,
  ry: 9.65748,
  transform: "matrix(0.956488 -0.291773 0.291775 0.956487 235.629 272.648)",
  fill: "url(#paint3_linear)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M357.556 263.102L337.566 238.623L330.014 244.791L350.004 269.27L357.556 263.102Z",
  fill: "#4035C2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 9.65752,
  ry: 9.65748,
  transform: "matrix(0.96274 0.27043 -0.270432 0.962739 356.317 272.346)",
  fill: "url(#paint4_linear)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M338.123 193.864L318.418 181.503C315.686 179.795 312.157 181.776 312.157 185.013V206.417C312.157 207.851 312.887 209.176 314.091 209.928L326.1 217.467L330.901 220.472C333.524 222.125 332.375 226.209 329.278 226.209H316.241C313.982 226.209 312.143 228.067 312.143 230.348V252.176C312.143 261.751 303.988 269.427 294.332 268.512C285.92 267.706 279.659 260.235 279.659 251.698V234.159V226.237V197.375C279.659 195.94 278.929 194.616 277.725 193.864L258.021 181.503C255.289 179.795 251.759 181.776 251.759 185.027V206.431C251.759 207.865 252.489 209.19 253.693 209.941L265.702 217.481L270.503 220.486C273.127 222.139 271.977 226.223 268.88 226.223H255.857C253.598 226.237 251.759 228.081 251.759 230.375V251.219C251.759 275.478 270.557 296.022 294.576 296.746C319.527 297.497 340.056 277.213 340.056 252.176V226.237V197.375C340.056 195.954 339.326 194.616 338.123 193.864Z",
  fill: "url(#paint5_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 8.1478,
  ry: 8.03122,
  transform: "matrix(0.748678 0.662934 0.662923 -0.748688 107.729 211.483)",
  fill: "#FBB54C"
});

var _ref16 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 8.14773,
  ry: 8.03113,
  transform: "matrix(0.748685 0.662926 0.66293 -0.748681 165.127 138.881)",
  fill: "#5BD8FF"
});

var _ref17 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 5.7035,
  ry: 5.62191,
  transform: "matrix(0.748673 0.66294 0.662917 -0.748693 205.941 179.115)",
  fill: "#40ED9A"
});

var _ref18 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.51813,
  ry: 6.42484,
  transform: "matrix(0.748691 0.662919 0.662937 -0.748675 151.766 240.44)",
  fill: "#EC6969"
});

var _ref19 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 9.77729,
  ry: 9.63738,
  transform: "matrix(0.748683 0.662928 0.662928 -0.748683 217.64 127.658)",
  fill: "#EC6969"
});

var _ref20 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 8.14779,
  ry: 8.03121,
  transform: "matrix(0.748677 0.662935 0.662922 -0.748689 258.541 95.1412)",
  fill: "#40ED9A"
});

var _ref21 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.05311,
  ry: 3.99509,
  transform: "matrix(0.748699 0.66291 0.662946 -0.748667 292.662 132.493)",
  fill: "#EC6969"
});

var _ref22 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 2.44432,
  ry: 2.40935,
  transform: "matrix(0.748678 0.662934 0.662922 -0.748688 134.067 161.882)",
  fill: "#FBB54C"
});

var _ref23 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 10.112,
  ry: 9.96733,
  transform: "matrix(0.748674 0.662938 0.662918 -0.748692 113.334 267.369)",
  fill: "#5E86EC"
});

var _ref24 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 8.14784,
  ry: 7.22814,
  transform: "matrix(0.748675 0.662937 0.66292 -0.748691 152.146 196.588)",
  fill: "#5E86EC"
});

var _ref25 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 8.33242,
  ry: 8.33247,
  transform: "matrix(0.931574 -0.363551 -0.363546 -0.931576 494.901 227.017)",
  fill: "#EC6969"
});

var _ref26 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 7.73723,
  ry: 7.73715,
  transform: "matrix(0.931577 -0.363544 -0.363553 -0.931574 428.322 164.523)",
  fill: "#FBB54C"
});

var _ref27 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.77954,
  ry: 4.77943,
  transform: "matrix(0.931579 -0.363538 -0.363558 -0.931572 378.262 169.752)",
  fill: "#5E86EC"
});

var _ref28 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 6.62868,
  ry: 6.62872,
  transform: "matrix(0.931575 -0.36355 -0.363546 -0.931576 411.23 202.355)",
  fill: "#EC6969"
});

var _ref29 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.7614,
  ry: 4.76147,
  transform: "matrix(0.931573 -0.363555 -0.363541 -0.931578 450.416 211.62)",
  fill: "#FBB54C"
});

var _ref30 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 5.95174,
  ry: 5.95181,
  transform: "matrix(0.931574 -0.363553 -0.363544 -0.931577 400.253 106.514)",
  fill: "#40ED9A"
});

var _ref31 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 5.95169,
  ry: 5.95143,
  transform: "matrix(0.931583 -0.36353 -0.363566 -0.931568 471.346 178.691)",
  fill: "#40ED9A"
});

var _ref32 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 5.35657,
  ry: 5.35657,
  transform: "matrix(0.931575 -0.363548 -0.363548 -0.931575 312.224 89.8816)",
  fill: "#5E86EC"
});

var _ref33 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 9.52281,
  ry: 9.52295,
  transform: "matrix(0.931573 -0.363555 -0.363542 -0.931578 486.748 280.267)",
  fill: "#5BD8FF"
});

var _ref34 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 4.1662,
  ry: 4.16623,
  transform: "matrix(0.931574 -0.363551 -0.363545 -0.931577 362.391 126.824)",
  fill: "#5BD8FF"
});

var _ref35 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 2.97588,
  ry: 2.97598,
  transform: "matrix(0.93157 -0.363562 -0.363535 -0.931581 396.398 142.52)",
  fill: "#5E86EC"
});

var _ref36 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 2.38068,
  ry: 2.38066,
  transform: "matrix(0.931577 -0.363545 -0.363551 -0.931574 354.69 97.5829)",
  fill: "#5BD8FF"
});

var _ref37 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(309.531 292.402) rotate(90) scale(263.846 263.846)"
}, React.createElement("stop", {
  offset: 0.703125,
  stopColor: "white"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E6EBFF"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 262.346,
  y1: 331.868,
  x2: 273.818,
  y2: 296.483,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 310.126,
  y1: 331.869,
  x2: 321.598,
  y2: 296.484,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 4.38192,
  y1: 25.8539,
  x2: 22.2319,
  y2: -1.6759,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 4.38192,
  y1: 25.8539,
  x2: 22.2319,
  y2: -1.6759,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 271.791,
  y1: 336,
  x2: 387.592,
  y2: 199.926,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#442BE0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B377FF"
})));

var SvgHumanULogoWithDome = function SvgHumanULogoWithDome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 623,
    height: 364,
    viewBox: "0 0 623 364",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHumanULogoWithDome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/humanULogoWithDome.a46b72e3.svg";
export { ForwardRef as ReactComponent };